import httpRequest from "@/services/httpRequest"

export default ({
    namespaced: true,
    state: {
        page: 1,
        rows: 20,
        paymentSummary: [],
        eduPaymentSummary: [],
    },
    mutations: {
        SET_PAYMENT_SUMMARY_FIRST(state, data) {
            state.paymentSummary = data
        },
        SET_EDU_PAYMENT_SUMMARY_FIRST(state, data) {
            state.eduPaymentSummary = data
        },

        SET_PAYMENT_SUMMARY(state, data) {
            data.forEach((item) => {
                state.paymentSummary.push(item)
            })
        },
        SET_EDU_PAYMENT_SUMMARY(state, data) {
            data.forEach((item) => {
                state.eduPaymentSummary.push(item)
            })
        }
    },
    actions: {
        async getPaymentSummary({commit, rootState, state}, status) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/studentpayment?page=${state.page}&rows=${state.rows}`,
                    method: 'GET',
                },
                authorized: true
            }
            
            const res = await httpRequest(payload)
            if (res.status === 200) {
                if (status === 'first') {
                    commit('SET_PAYMENT_SUMMARY_FIRST', res.data.results)
                } else {
                    commit('SET_PAYMENT_SUMMARY', res.data.results)
                }
            }
        },

        async getEduPaymentSummary({commit, rootState,state}, status) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/studentedupayment?page=${state.page}&rows=${state.rows}`,
                    method: 'GET',
                },
                authorized: true
            }

            const res = await httpRequest(payload)
            if (res.status === 200) {
                if (status === 'first') {
                    commit('SET_EDU_PAYMENT_SUMMARY_FIRST', res.data.results)
                } else {
                    commit('SET_EDU_PAYMENT_SUMMARY', res.data.results)
                }
            }
        }
    }
})